module.exports = __webpack_public_path__ + "media/music_7.793ebfb1.mp3";